import React from 'react';
export function Footer() {
  return <footer className="py-16 md:py-20 bg-obsidian border-t border-white/5" data-id="element-35">
      <div className="max-w-7xl mx-auto px-6 md:px-8 text-center" data-id="element-36">
        <div className="flex justify-center items-center font-serif text-3xl md:text-4xl tracking-widest mb-12" data-id="element-37">
          <span className="text-crimson" data-id="element-38">D</span>
          <span className="text-champagne border border-champagne px-3 py-1 leading-none flex items-center justify-center" data-id="element-39">
            14
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-12 mb-16 text-xs md:text-sm uppercase tracking-[0.3em] font-sans text-white/60" data-id="element-40">
          <div data-id="element-41">
            <h4 className="text-white mb-4" data-id="element-42">Location</h4>
            <p data-id="element-43">1234 Crimson Way NW</p>
            <p data-id="element-44">Washington, DC 20001</p>
          </div>
          <div data-id="element-45">
            <h4 className="text-white mb-4" data-id="element-46">Hours</h4>
            <p data-id="element-47">Wed — Sat: 21:00 - 03:00</p>
            <p data-id="element-48">Sun: 20:00 - 02:00</p>
          </div>
          <div data-id="element-49">
            <h4 className="text-white mb-4" data-id="element-50">Contact</h4>
            <p data-id="element-51">concierge@district14dc.com</p>
            <p data-id="element-52">+1 (202) 555-0123</p>
          </div>
        </div>

        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-53">
          <p className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-white/40" data-id="element-54">
            © 2026 District 14. All Rights Reserved.
          </p>
          <div className="flex gap-8 text-[10px] md:text-xs uppercase tracking-[0.2em] text-white/60" data-id="element-55">
            <a href="#" className="hover:text-champagne transition-colors" data-id="element-56">
              Instagram
            </a>
            <a href="#" className="hover:text-champagne transition-colors" data-id="element-57">
              Facebook
            </a>
            <a href="#" className="hover:text-champagne transition-colors" data-id="element-58">
              Privacy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}